// @owners { team: patients }
import { ActionSheetContext, ActionSheetV2 } from '@alto/design-system';
import React, { useContext } from 'react';
import { CONTACT_US_ORIGIN } from '~shared/constants';
import { ContactUs } from '../../alto-assistant';
import { USE_SOMETHING_ELSE_LABEL } from '../constants';

const DESCRIPTION = 'To use another discount or pricing option, contact our Care Team for assistance.';

type Props = {
  readonly phoneNumber: string;
};

export const ContactCareActionSheet = ({ phoneNumber }: Props) => {
  const { closeActionSheet } = useContext(ActionSheetContext);

  return (
    <ActionSheetV2
      analyticsName="contact_care_action_sheet"
      description={DESCRIPTION}
      title={USE_SOMETHING_ELSE_LABEL}
      buttons={[
        <ContactUs
          key="message"
          type="button"
          method="message"
          origin={CONTACT_US_ORIGIN.ContactCareActionSheet}
          onPressCallback={closeActionSheet}
        />,
        <ContactUs
          key="call"
          type="button"
          buttonType="tertiary"
          method="phone"
          customLabel={`Call ${phoneNumber}`}
          customPhoneNumber={phoneNumber}
          origin={CONTACT_US_ORIGIN.ContactCareActionSheet}
        />,
      ]}
    />
  );
};
